import type { BulkFieldValue } from '../../../../types'

import { format } from 'date-fns/esm'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { selectUserConfiguration } from '@/features/domain/user'

export function useActions(
  apiChange: (value: BulkFieldValue<uui.domain.client.rm.Eligibility>) => void,
) {
  const { today } = useSelector(selectUserConfiguration)

  const onChangeEligibilityType = useCallback(
    (type: uui.domain.client.rm.Eligibility['type']) => {
      switch (type) {
        case 'any':
          apiChange({ status: 'exact', value: { type } })
          break

        case 'on':
          apiChange({ status: 'exact', value: { type, dates: [today] } })
          break

        case 'by':
          apiChange({ status: 'exact', value: { type, date: today } })
          break
      }
    },
    [apiChange, today],
  )

  const onChangeDate = useCallback(
    (type: uui.domain.client.rm.Eligibility['type'], dates: Date[]) => {
      switch (type) {
        case 'any':
          apiChange({ status: 'exact', value: { type } })
          break

        case 'on': {
          const datesAsString = dates.map(d => format(d, 'yyyyMMdd'))
          apiChange({
            status: 'exact',
            value: {
              type,
              dates: datesAsString,
            },
          })
          break
        }

        case 'by': {
          const date = format(dates[0], 'yyyyMMdd')
          apiChange({
            status: 'exact',
            value: {
              type,
              date,
            },
          })
          break
        }
      }
    },
    [apiChange],
  )

  return {
    onChangeEligibilityType,
    onChangeDate,
  }
}
